<template>
  <div>
    <v-row justify="end">
      <v-col cols="12" sm="6" lg="4" xl="3">
        <v-btn block outlined color="primary" @click="$emit('addTeamMember')">
          Add Member
          <v-icon right >add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <TeamMemberInput
      class="mt-3"
      v-for="(item, index) in teamMembers" :key="index"
      :id="index"
      :memberId="item.memberId"
      :role="item.role"
      :showDeleteButton="true"
      @memberIdChange="memberIdChangeHandler"
      @roleChange="roleChangeHandler"
      @removeMember="(id) => $emit('removeMember', id)"
    ></TeamMemberInput>
  </div>
</template>

<script>
import TeamMemberInput from '@/components/teams/TeamMemberInput'

export default {
  props: [
    'teamMembers'
  ],
  components: {
    TeamMemberInput
  },
  methods: {
    memberIdChangeHandler ({ id, memberId }) {
      this.$emit('memberIdChange', { id, memberId })
    },
    roleChangeHandler ({ id, role }) {
      this.$emit('roleChange', { id, role })
    }
  }
}
</script>
